import { ENTREGAS_URL, IDUSUARIO, customAxios } from '../constants';
import { FETCH_LUGARES_DESPACHO, FETCHLUGARES_ENTREGA, FETCH_DIAS_ENTREGA, FETCH_UBICACION_PEDIDO, FETCH_TIPO_FILIAL_ENTREGA, FETCH_CAPACIDADES, LOAD_MANTENIMIENTO } from '../actions';
import { evalAction, serverError } from '../utils/actionError';

export function fetchLugaresDespacho(
  filiales = [],
  familias = [],
  tipoActividad = [],
  cantMaxUnidades = '',
  nroPag = 1,
) {
  const config = {
    headers: {
      idUsuario: IDUSUARIO,
      indPaginado: 'S',
      nroPag,
      cantidadxPag: '10',
    },
    params: {
      codFilial: filiales.length ? `[${filiales}]` : null,
      codFamilia: familias.length ? `[${familias}]` : null,
      tipoActividad: tipoActividad.length ? `[${tipoActividad}]` : null,
      cantMaxUnidades,
    },
  };

  const request = customAxios.get(`${ENTREGAS_URL}/entrega-vehiculo-maestro/lugares-despacho`, config)
                                .then(({ data }) => evalAction(data, 'lugaresDespacho'))
                                .catch(error => serverError(error, 'lugaresDespacho'));

  return {
    type: FETCH_LUGARES_DESPACHO,
    payload: request,
  };
}

export function fetchLugaresEntrega(
  codFamVeh = '',
  codFilial = '',
  nroPag = 1
) {
  const config = {
    headers: {
      idUsuario: IDUSUARIO,
      indPaginado: 'S',
      nroPag,
      cantidadxPag: '10',
    },
    params: {
      codFamVeh,
      codFilial,
    },
  };

  const request = customAxios.get(`${ENTREGAS_URL}/entrega-vehiculo-maestro/lugares-entrega`, config)
                                .then(({ data }) => evalAction(data, 'mantLugarEntrega'))
                                .catch(error => serverError(error, 'mantLugarEntrega'));

  return {
    type: FETCHLUGARES_ENTREGA,
    payload: request,
  };
}

export function fetchDiasEntrega(codSucuOrig = '', codSucuDest = '', canDias = '', nroPag = 1) {
  const config = {
    headers: {
      codIdUsuario: IDUSUARIO,
      indPaginado: 'S',
      nroPag,
      cantidadxPag: '10',
    },
    params: {
      codSucuOrig,
      codSucuDest,
      canDias,
    },
  };

  const request = customAxios.get(`${ENTREGAS_URL}/entrega-vehiculo-maestro/dias-planificaciones-entregas`, config)
                                .then(({ data }) => evalAction(data, 'planificacionDiasEntrega'))
                                .catch(error => serverError(error, 'planificacionDiasEntrega'));

  return {
    type: FETCH_DIAS_ENTREGA,
    payload: request,
  };
}

export function fetchUbicacionPedido(codSucursal = '', codWerksSap = '',codFilial='', nroPag = 1,buscar='') {
  const config = {
    headers: {
      codIdUsuario: IDUSUARIO,
      indPaginado: 'S',
      nroPag,
      cantidadxPag: '10',
    },
    params: {
      codSucursal,
      codWerksSap,
      codFilial,
      desUbicaPedido:buscar,
    },
  };

  const request = customAxios.get(`${ENTREGAS_URL}/entrega-vehiculo-maestro/ubicaciones-pedidos`, config)
                                .then(({ data }) => evalAction(data, 'listaUbicacionPedido'))
                                .catch(error => serverError(error, 'listaUbicacionPedido'));

  return {
    type: FETCH_UBICACION_PEDIDO,
    payload: request,
  };
}

export function fetchTipoFilialEntrega(codFilial = '', indTipoFilial = '', nroPag = 1) {
  const config = {
    headers: {
      indPaginado: 'S',
      nroPag,
      cantidadxPag: '10',
    },
    params: {
      codFilial,
      indTipoFilial,
    },
  };

  const request = customAxios.get(`${ENTREGAS_URL}/entrega-vehiculo-maestro/tipos-filiales-entregas`, config)
                                .then(({ data }) => evalAction(data, 'tipoFilial'))
                                .catch(error => serverError(error, 'tipoFilial'));

  return {
    type: FETCH_TIPO_FILIAL_ENTREGA,
    payload: request,
  };
}

export function fetchTipoCapacidades(codFilial = '', codFamilia = '', codCapacidad, nroPag = 1) {
  const config = {
    headers: {
      indPaginado: 'S',
      nroPag,
      cantidadxPag: '10',
      idUsuario: IDUSUARIO,

    },
    params: {
      codFilial,
      codFamVeh: codFamilia,
      indTipoCapa: codCapacidad,
    },
  };

  const request = customAxios.get(`${ENTREGAS_URL}/entrega-vehiculo-maestro/ampliacion-capacidades`, config)
                                .then(({ data }) => evalAction(data, 'ampliacionCapacidad'))
                                .catch(error => serverError(error, 'ampliacionCapacidad'));

  return {
    type: FETCH_CAPACIDADES,
    payload: request,
  };
}


export function loadMantenimiento() {
  return {
    type: LOAD_MANTENIMIENTO,
  };
}



// WEBPACK FOOTER //
// ./src/actions/MantenimientoEntrega.js